/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-slides.vue?vue&type=template&id=2d00b73e&scoped=true"
import script from "./pc-slides.vue?vue&type=script&lang=js"
export * from "./pc-slides.vue?vue&type=script&lang=js"
import style0 from "./pc-slides.vue?vue&type=style&index=0&id=2d00b73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00b73e",
  null
  
)

export default component.exports
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QTabs,QTab});
